export function ucfirst(string) {

    return string.split(',').map(con => con.charAt(0).toUpperCase() + con.slice(1)).join();
}